import { createSvgIcon } from "@mui/material";
import ponctDash from "../Assets/Images/ponct_dash.svg";
import loginIllustration from "../Assets/Images/login_illustration.svg";
import step_icon from '../Assets/Images/step_icon.svg'
import step_icon2 from '../Assets/Images/step_icon2.svg'
import iconLoader from "../Assets/Icons/loader-bleu.gif";
import money from "../Assets/Icons/money-rem.svg" 
import money2 from "../Assets/Icons/news/money2.svg" 
import money3 from "../Assets/Icons/news/money3.svg" 
import edits from "../Assets/Icons/edit-1.svg"
import deletes from "../Assets/Icons/delete-2.svg"
import student from '../Assets/Icons/news/iconStudent.svg'
import account from '../Assets/Icons/news/iconAccount.svg'
import punctualCours from '../Assets/Icons/news/iconCoursPunctual.svg'
import moreCours from '../Assets/Icons/news/iconMoreCours.svg'
import cours from '../Assets/Icons/news/iconCours.svg'
import declare from '../Assets/Icons/news/iconDeclare.svg'
import demandeCours from '../Assets/Icons/news/demandeCours.svg'
import noCourse from '../Assets/Icons/news/no-course.svg'
import noChild from '../Assets/Icons/news/noChild.svg'
import archive from '../Assets/Icons/news/archive.jpg'
import historic from '../Assets/Icons/news/historic.jpg'
import logo_blanc from "../Assets/Images/logo_blanc.svg";
import logo_degrade from "../Assets/Images/logo_bleu.png";
import logo_mobile from "../Assets/Icons/news/LogoMobile.svg";
import logo_mobile_white from "../Assets/Icons/news/logoBlancMobile.svg";
import google_icon from '../Assets/Icons/google.svg'
import apple_icon from '../Assets/Icons/apple.svg'
import facebook_icon from '../Assets/Icons/facebook.svg'
import Sms_icon from '../Assets/Icons/sms.svg';
import Calendar_icon from '../Assets/Images/Vector (1).png'
import info_acre from "../Assets/Icons/info-acre.svg";
import animation from "../Assets/Icons/news/animation.gif";
import removeDialogue from "../Assets/Icons/news/remove.svg";
import nouneuro from "../Assets/Icons/nouneuro.svg"
import exempl1 from '../Assets/Icons/news/example-1.webp'
import exempl2 from '../Assets/Icons/news/example-2.webp'
import exempl3 from '../Assets/Icons/news/example-3.webp'
import exempl4 from '../Assets/Icons/news/example-4.webp'
import parrainage from '../Assets/Icons/news/parrainagePicture.svg'
import avatarH from '../Assets/Icons/news/avatarH.svg'
import avatarF from '../Assets/Icons/news/avatarF.svg'
import { ENV_TEACHR, ENV_VERIFIED_TRAINER, isBrandActive } from "../config/environment.config";
import pictDec from "../Assets/Images/bgVtLastDec.svg"
import picture from "../Assets/Images/Validation_1.gif"
import pictureDec from "../Assets/Images/pictureCongrat.svg"
import pictureAward1 from "../Assets/Images/picture_award.svg"
import pictureProgress1 from "../Assets/Images/picture_progress.svg"
import boardingAiciImg from '../Assets/Images/bg-aici-boarding.svg';

export const iconStudent = (): any => {return  (<img src={student} alt="student image" className={"w-auto h-5 mr-"} />) }
export const iconDeclare = (): any => {return  (<img src={cours} alt="cours declare image" className={"h-5 w-4 mr-"} />) }
export const pictureCongrat = isBrandActive(ENV_TEACHR) ? picture : isBrandActive(ENV_VERIFIED_TRAINER) ? pictDec : pictureDec ;
export const imgPonctualDash = ponctDash ;
export const loader = iconLoader;
export const iconMoney =  isBrandActive(ENV_TEACHR) ? money : isBrandActive(ENV_VERIFIED_TRAINER) ? money2 : money3 ;
export const iconEdit = edits ;
export const iconDelete =  deletes ;
export const iconAccount = account
export const iconPunctualCours = punctualCours
export const iconMoreCours = moreCours
export const srcCours = cours
export const srcDeclare = declare
export const srcDemandeCours = demandeCours
export const srcNoCourse = noCourse
export const srcNoChild = noChild
export const srcArchive = archive
export const srcHistoric = historic 
export const srcLogin = loginIllustration
export const logoWhite = logo_blanc
export const logoBlue = logo_degrade
export const logoMobile = logo_mobile
export const logoMobileWhite = logo_mobile_white
export const googleIcon = google_icon
export const appleIcon = apple_icon
export const facebookIcon = facebook_icon
export const SmsIcon = Sms_icon
export const CalendarIcon = Calendar_icon
export const info = info_acre
export const stepIcon = step_icon
export const stepIcon2 = step_icon2
export const animationTeachr = animation
export const iconRemove = removeDialogue
export const nounEuro = nouneuro
export const exemple1 = exempl1
export const exemple2 = exempl2
export const exemple3 = exempl3
export const exemple4 = exempl4
export const sponsor = parrainage
export const avatarMale = avatarH;
export const avatarFemale = avatarF;
export const pictureAward = pictureAward1;
export const pictureProgress = pictureProgress1;
export const boardingAici = boardingAiciImg;
export const CalendarIcons = createSvgIcon(
    <path d="M0.443359 31.3125C0.443359 33.0723 1.93108 34.5 3.76479 34.5H28.1219C29.9556 34.5 31.4434 33.0723 31.4434 31.3125V13.25H0.443359V31.3125ZM22.5862 18.2969C22.5862 17.8586 22.9599 17.5 23.4166 17.5H26.1844C26.6411 17.5 27.0148 17.8586 27.0148 18.2969V20.9531C27.0148 21.3914 26.6411 21.75 26.1844 21.75H23.4166C22.9599 21.75 22.5862 21.3914 22.5862 20.9531V18.2969ZM22.5862 26.7969C22.5862 26.3586 22.9599 26 23.4166 26H26.1844C26.6411 26 27.0148 26.3586 27.0148 26.7969V29.4531C27.0148 29.8914 26.6411 30.25 26.1844 30.25H23.4166C22.9599 30.25 22.5862 29.8914 22.5862 29.4531V26.7969ZM13.7291 18.2969C13.7291 17.8586 14.1027 17.5 14.5594 17.5H17.3273C17.784 17.5 18.1576 17.8586 18.1576 18.2969V20.9531C18.1576 21.3914 17.784 21.75 17.3273 21.75H14.5594C14.1027 21.75 13.7291 21.3914 13.7291 20.9531V18.2969ZM13.7291 26.7969C13.7291 26.3586 14.1027 26 14.5594 26H17.3273C17.784 26 18.1576 26.3586 18.1576 26.7969V29.4531C18.1576 29.8914 17.784 30.25 17.3273 30.25H14.5594C14.1027 30.25 13.7291 29.8914 13.7291 29.4531V26.7969ZM4.87193 18.2969C4.87193 17.8586 5.24559 17.5 5.70229 17.5H8.47014C8.92684 17.5 9.3005 17.8586 9.3005 18.2969V20.9531C9.3005 21.3914 8.92684 21.75 8.47014 21.75H5.70229C5.24559 21.75 4.87193 21.3914 4.87193 20.9531V18.2969ZM4.87193 26.7969C4.87193 26.3586 5.24559 26 5.70229 26H8.47014C8.92684 26 9.3005 26.3586 9.3005 26.7969V29.4531C9.3005 29.8914 8.92684 30.25 8.47014 30.25H5.70229C5.24559 30.25 4.87193 29.8914 4.87193 29.4531V26.7969ZM28.1219 4.75H24.8005V1.5625C24.8005 0.978125 24.3023 0.5 23.6934 0.5H21.4791C20.8701 0.5 20.3719 0.978125 20.3719 1.5625V4.75H11.5148V1.5625C11.5148 0.978125 11.0166 0.5 10.4076 0.5H8.19336C7.58443 0.5 7.08622 0.978125 7.08622 1.5625V4.75H3.76479C1.93108 4.75 0.443359 6.17773 0.443359 7.9375V11.125H31.4434V7.9375C31.4434 6.17773 29.9556 4.75 28.1219 4.75Z" fill="#4D4D4D" />,
    'Calendar',
  );
